import { render, staticRenderFns } from "./LogoWidget.vue?vue&type=template&id=7996e671&"
import script from "./LogoWidget.vue?vue&type=script&lang=js&"
export * from "./LogoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports